// Every card on the player page is centred in one narrow column; sharing the
// width keeps a new card flush with the header, profile, contacts and table.
export const PLAYER_PAGE_CARD_MAX_WIDTH = 480;
